import React from "react";
import { useRoutes } from "react-router-dom";

const LoginComponent = React.lazy(() => import("../pages/login/index"));
const RegisterComponent = React.lazy(() => import("../pages/register/index"));
const HomeComponent = React.lazy(() => import("../pages/home/index"));
const Level1Component = React.lazy(() => import("../pages/level1/index"));
const Level2Component = React.lazy(() => import("../pages/level2/index"));
const Level3Component = React.lazy(() => import("../pages/level3/index"));
const Level4Component = React.lazy(() => import("../pages/level4/index"));
const Level5Component = React.lazy(() => import("../pages/level5/index"));
const Level6Component = React.lazy(() => import("../pages/level6/index"));
const Level7Component = React.lazy(() => import("../pages/level7/index"));
const Level8Component = React.lazy(() => import("../pages/level8/index"));
const Level9Component = React.lazy(() => import("../pages/level9/index"));
const Level10Component = React.lazy(() => import("../pages/level10/index"));
const Level11Component = React.lazy(() => import("../pages/level11/index"));
const Level12Component = React.lazy(() => import("../pages/level12/index"));
const RoleComponent = React.lazy(() => import("../pages/role/index"));
const ResetpswdComponent = React.lazy(() => import("../pages/resetpswd/index"));
const PointsComponent = React.lazy(() => import("../pages/points/index"));
const LevelResultComponent = React.lazy(() => import("../pages/level_result/index"));
const SettingComponent = React.lazy(() => import("../pages/setting/index"));
const UserComponent = React.lazy(() => import("../pages/user/index"));
const QuestionnaireComponent = React.lazy(() => import("../pages/questionnaire/index"));

const FrameCompont = React.lazy(() => import("../pages/frame/index"));

const MessageBoardComponent = React.lazy(() => import("../pages/message_board/index"));

const AddMessageComponent = React.lazy(() => import("../pages/add_message/index"));

export default function () {
  return useRoutes([
    {
      label: "首页",
      key: "index",
      path: "/",
      element: <HomeComponent />,
    },
    {
      label: "登录",
      key: "login",
      path: "/login",
      element: <LoginComponent />,
    },
    {
      label: "注册",
      key: "register",
      path: "/register",
      element: <RegisterComponent />,
    },
    {
      label: "角色选择",
      key: "role",
      path: "/role",
      element: <RoleComponent />,
    },
    {
      label: "首页",
      key: "home",
      path: "/homepage",
      element: <HomeComponent />,
    },
    {
      label: "神秘图书馆",
      key: "level_1",
      path: "/level_1",
      element: <Level1Component />,
    },
    {
      label: "解谜",
      key: "level_2",
      path: "/level_2",
      element: <Level2Component />,
    },
    {
      label: "被遗忘的寺庙",
      key: "level_3",
      path: "/level_3",
      element: <Level3Component />,
    },
    {
      label: "太阳之谜",
      key: "level_4",
      path: "/level_4",
      element: <Level4Component />,
    },
    {
      label: "level5",
      key: "level_5",
      path: "/level_5",
      element: <Level5Component />,
    },
    {
      label: "level6",
      key: "level_6",
      path: "/level_6",
      element: <Level6Component />,
    },
    {
      label: "level7",
      key: "level_7",
      path: "/level_7",
      element: <Level7Component />,
    },
    {
      label: "level8",
      key: "level_8",
      path: "/level_8",
      element: <Level8Component />,
    },
    {
      label: "level9",
      key: "level_9",
      path: "/level_9",
      element: <Level9Component />,
    },
    {
      label: "level10",
      key: "level_10",
      path: "/level_10",
      element: <Level10Component />,
    },
    {
      label: "level11",
      key: "level_11",
      path: "/level_11",
      element: <Level11Component />,
    },
    {
      label: "level12",
      key: "level_12",
      path: "/level_12",
      element: <Level12Component />,
    },
    {
      label: "找回密码",
      key: "resetpswd",
      path: "/resetpswd",
      element: <ResetpswdComponent />,
    },
    {
      label: "积分",
      key: "points",
      path: "/points",
      element: <PointsComponent />,
    },
    {
      label: "答题结果",
      key: "result",
      path: "/result",
      element: <LevelResultComponent />,
    },
    {
      label: "设置",
      key: "setting",
      path: "/setting",
      element: <SettingComponent />,
    },
    {
      label: "个人信息",
      key: "user",
      path: "/user",
      element: <UserComponent />,
    },
    {
      label: "问卷",
      key: "questionnaire",
      path: "/questionnaire",
      element: <QuestionnaireComponent />,
    },
    {
      label: "frame",
      key: "frame",
      path: "/frame",
      element: <FrameCompont />,
    },
    {
      label: "留言板",
      key: "messageboard",
      path: "/messageboard",
      element: <MessageBoardComponent />,
    },
    {
      label: "addmessage",
      key: "addmessage",
      path: "/addmessage",
      element: <AddMessageComponent />,

    }
  ]);
}
